export type ReachStatus = 'exact' | 'pending' | 'approximate';

export const REACH_POLL_INTERVAL_MS = 5000;
// Meta async Insights jobs often take longer than a minute, especially when
// current and prior windows are both cache misses.
export const REACH_POLL_TIMEOUT_MS = 180000;

export const REACH_APPROXIMATE_TOOLTIP =
  'Sum of daily unique reach. People reached on multiple days may be counted more than once.';

export const isReachPending = (status?: string | null): boolean => status === 'pending';

export const isReachApproximate = (
  status?: string | null,
  timedOut?: boolean,
): boolean => status === 'approximate' || (isReachPending(status) && timedOut);

export const getEffectiveReachStatus = (
  status?: string | null,
  timedOut = false,
): ReachStatus | undefined => {
  if (!status) return undefined;
  if (isReachPending(status) && timedOut) return 'approximate';
  if (status === 'exact' || status === 'pending' || status === 'approximate') {
    return status;
  }
  return undefined;
};

export const shouldShowReachMetricCard = (
  reach?: number,
  reachStatus?: string | null,
): boolean => {
  if (isReachPending(reachStatus) || reachStatus === 'approximate') {
    return true;
  }
  return typeof reach !== 'undefined' && reach !== 0;
};

export const isReachComparisonPending = (
  currentStatus?: string | null,
  pastStatus?: string | null,
): boolean => isReachPending(currentStatus) || isReachPending(pastStatus);
